/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface SetPasswordResponse
 */
export interface SetPasswordResponse {
    /**
     * 
     * @type {User}
     * @memberof SetPasswordResponse
     */
    data: User;
}

/**
 * Check if a given object implements the SetPasswordResponse interface.
 */
export function instanceOfSetPasswordResponse(value: object): value is SetPasswordResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SetPasswordResponseFromJSON(json: any): SetPasswordResponse {
    return SetPasswordResponseFromJSONTyped(json, false);
}

export function SetPasswordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasswordResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': UserFromJSON(json['data']),
    };
}

  export function SetPasswordResponseToJSON(json: any): SetPasswordResponse {
      return SetPasswordResponseToJSONTyped(json, false);
  }

  export function SetPasswordResponseToJSONTyped(value?: SetPasswordResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UserToJSON(value['data']),
    };
}

